import { prepParticipateRoute } from ".";
export var participateRoute = prepParticipateRoute();
